import { components } from "@/api-schema";
import { MergeEntityName } from "@/api-schema-enums";
import { cn } from "@/common/helpers/utils";
import { ArrowRight } from "lucide-react";
import { useTranslation } from "react-i18next";
import { MergeTargetCombobox } from "../merge-target-combobox";

type MergeEntityRef = components["schemas"]["MergeEntitySummaryResponse"];

interface PickTargetStepProps {
  entity: MergeEntityName;
  source: MergeEntityRef;
  targetUuid: string;
  targetLabel: string;
  onTargetChange: (uuid: string, label: string, logoUrl?: string) => void;
}

export const PickTargetStep = ({ entity, source, targetUuid, targetLabel, onTargetChange }: PickTargetStepProps) => {
  const { t } = useTranslation("masterdata");

  return (
    <div className="space-y-4">
      <p className="text-muted-foreground text-sm">
        {t("SelectTheRecordToMergeInto", {
          name: source.label,
        })}
      </p>

      <div className="space-y-1.5">
        <label className="text-sm font-medium">{t("MergeTarget")}</label>
        <MergeTargetCombobox entity={entity} value={targetUuid} onChange={onTargetChange} excludeUuid={source.uuid} />
      </div>

      <div className="border-border bg-muted/30 flex items-center gap-3 rounded-md border p-3 text-sm">
        <div className="flex-1 text-center">
          <p className="font-medium">{source.label}</p>
          <p className="text-muted-foreground text-xs">{t("WillBeDeleted")}</p>
        </div>
        <ArrowRight className="text-muted-foreground h-4 w-4 shrink-0" />
        <div className="flex-1 text-center">
          <p className={cn("font-medium", targetLabel ? "text-primary" : "text-muted-foreground")}>
            {targetLabel || t("NotSelected")}
          </p>
          <p className={cn("text-xs", targetLabel ? "text-primary" : "text-muted-foreground")}>{t("WillBeKept")}</p>
        </div>
      </div>
    </div>
  );
};
